'use strict';

var $ = require('jquery');
var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var polyglot = require('../../utilities/polyglot').default;

var StaffItemView = require('../staff/select-item').default;

export default Marionette.CollectionView.extend({

  id: 'staff-select',
  className: 'staff-select',
  tagName: 'select',
  childView: StaffItemView,

  initialize: function (options) {
    this.selectedStaff = options.selectedStaff;
    // TODO: to remove the rendered flag, find a way to prevent this CollectionView from rendering twice or don't use a CollectionView
    this.rendered = false;
  },

  getSupportedLanguages: function () {
    return window.ALL_STAFF_LANGUAGES.filter(language => (
      this.collection.some(user => (
        user.get('supported_locale').split(',').includes(language.abbr)
      ))
    ));
  },

  onRender: function () {
    this.supportedLanguages = this.getSupportedLanguages();

    if (!this.rendered) {
      const select = this.$el.select2({
        width: '100%',
        templateResult: this.buildOptionContent,
        templateSelection: this.buildSelectionContent,
      });

      select.on('select2:open', () => {
        $('.select2-search__field').attr('placeholder', polyglot.t('staff_select.search'));
        $('.staff-select-container .option-content i').removeClass('fa-chevron-down').addClass('fa-chevron-up');
      });

      select.on('select2:close', () => {
        $('.staff-select-container .option-content i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
      });

      select.on('select2:select', ({ params: { data } }) => {
        let model = this.collection.get(data.id);

        if (!model) {
          const locale = data.element.getAttribute('language');

          if (locale) {
            const filteredStaff = this.collection.filter(staff => (
              staff.get('supported_locale').includes(locale)
            ));

            if (filteredStaff.length > 0) {
              model = {
                id: filteredStaff.map(staff => staff.id).join(','),
              };
            }
          }
        }

        this.triggerMethod('change:staff', model);
      });
    }

    if (this.needsPickForMe()) {
      this.addPickForMeOptions();
    }

    // fix for Microsoft IE11 and Edge not respecting the selected attribute
    const index = this.selectedStaff
      ? this.$el.find(`option[value="${this.selectedStaff.id}"]`).index()
      : 0;
    this.$el.prop('selectedIndex', index);

    this.rendered = true;
  },

  buildSelectionContent: function (state) {
    if (!state.element) {
      return state.text;
    }

    const arrow = '<i class="fa fa-chevron-down"/>';
    const locales = state.element.getAttribute('supportedLocales');
    let badges = '';

    if (locales) {
      locales.split(',').forEach((locale) => {
        badges += `<span class="badge">${locale}</span>`;
      });
    }

    return $(`<span class="option-content"><span class="name">${state.text}${badges}</span>${arrow}</span>`);
  },


  buildOptionContent: function (state) {
    if (!state.element) {
      return state.text;
    }

    const locales = state.element.getAttribute('supportedLocales');

    if (!locales) {
      return state.text;
    }

    let content = `<span class="option-content">${state.text}`;

    locales.split(',').forEach((locale) => {
      content += `<span class="badge">${locale}</span>`;
    });

    content += '</span>';

    return $(content);
  },

  addPickForMeOptions: function () {
    if (this.supportedLanguages.length > 1) {
      /*
        Constrained to prepend LanguageOptions one at a time to StaffOptions.
        Iterates in reverse order to create desired feed order.
      */
      this.supportedLanguages.reverse().forEach((language, i) => {
        // Want a divider on the last language option rendered in the list
        const id = `pick-for-me-${language.abbr}${i === 0 ? '-divider' : ''}`;
        const name = polyglot.t('staff_select.anyone_speaks', { language: language.name });

        this.addPickForMeOption(id, name, { language: language.abbr });
      });
    } else {
      const id = 'pick-for-me-divider';
      const name = polyglot.t('staff_select.anyone');
      const attributes = this.selectedStaff ? {} : { selected: 'selected' };

      this.addPickForMeOption(id, name, attributes);
    }
  },

  addPickForMeOption: function (id, name, attributes) {
    const child = new Backbone.Model({
      id,
      full_name: name,
    });
    const params = {
      model: child,
      attributes,
    };
    const ChildView = new StaffItemView(params);

    this.pickForMeModel = child;
    this.addChildView(ChildView, 0);
  },

  needsPickForMe: function () {
    return this.collection.length > 1;
  },
});
